import {Dimensions, StyleSheet} from 'react-native';
import {getOs} from '@buncha/utils/appInfo';
import {scaleFonts} from '@buncha/appStyles/style/font';

const BottomSheetStyle = StyleSheet.create({
  mainContainer: {
    paddingHorizontal: 10,
    width: '100%',
  },
  imageContainer: {
    height: 125,
    width: '100%',
    marginBottom: 15,
  },
  leftAlign: {
    textAlign: 'left',
    marginBottom: 15,
  },
  inputContainer: {
    borderWidth: 1,
    height: 51,
    width: '100%',
    borderRadius: 12,
    marginBottom: 15,
  },
  inputBox: {
    marginTop: getOs() === 'android' ? scaleFonts(20, 'height') : 0,
    borderWidth: 1,
    borderColor: 'red',
  },
  bottomButton: {
    width: '100%',
  },
  bagQuantityContainer: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  bagQuantityPill: {
    borderWidth: 1,
    padding: 10,
    borderRadius: 50,
  },
  addIconContainer: {paddingVertical: 5},
  inputStyle: {
    width: Dimensions.get('screen').width * 0.18,
    height: Dimensions.get('screen').height * 0.02,
  },
  bagQuantityBox: {
    marginBottom: 10,
  },
  hitSlopStyles: {
    top: 25,
    bottom: 25,
    left: 15,
    right: 15,
  },
});

export {BottomSheetStyle};
